export default "__VITE_ASSET__DBXcBSp1__"